// @flow
export const PINNED_PROPERTY_SET_LABEL = 'PINNED_PROPERTY/SET_LABEL';

type PinnedPropertySetLabelActionType = 'PINNED_PROPERTY/SET_LABEL';

type PinnedPropertySetLabelAction = {
    type: PinnedPropertySetLabelActionType,
    payload: {label: string}
};
export type Action = PinnedPropertySetLabelAction;

const ACTION_CREATORS = {
    setPinnedPropertyLabel(label: string): PinnedPropertySetLabelAction {
        return {
            type: PINNED_PROPERTY_SET_LABEL,
            payload: {label}
        };
    }
};

export default {
    ...ACTION_CREATORS
};
